import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 100px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 30px;
`;

export const NavImage = styled.img`
  height: 400px;
  margin-top: 20px;
`;

export const TopBar = styled.img`
  width: 50px;
`;

export const BottomBox = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: -40px;
`;

export const LeftBox = styled.div``;

export const LeftImage = styled.img``;

export const RightBox = styled.div`
  display: flex;
  flex-direction: column;
  text-align: end;
  padding-right: 50px;
  width: 60%;
  gap: 30px;
`;

export const TitleTxt = styled.div`
  font-size: 49.2px;
  font-weight: bold;
  color: #971a35;
`;

export const SubTitleTxt = styled.div`
  font-size: 22px;
  font-weight: semi-bold;
  color: #971a35;
`;

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: start;
  gap: 30px;
`;

export const TopText = styled.div`
  font-size: 22px;
`;

export const MiddleText = styled.div`
  font-size: 22px;
`;

export const BottomText = styled.div`
  font-size: 22px;
`;
